import React from "react";
import { withTranslation } from 'react-i18next';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';


import iconoLeyendaBlanco from '../../images/btn_filtros/leyenda_btn_blanco.png'
import leyMarkerSibc from "../../images/btn_filtros/sibic_marker.png"
import leyMarkerEasin from "../../images/btn_filtros/easin_marker.png"
import iconoCapaHeatmap from '../../images/btn_filtros/heatmap_capa.png'
import iconoCapaCluster from '../../images/btn_filtros/cluster_capa.png'

import i18next from 'i18next';

class Legend extends React.Component {

    shouldComponentUpdate(nextProps, nextState){

        return false
    }

    componentDidMount(){
        i18next.on('languageChanged', () => {this.forceUpdate()})
    }

    render() {

        const { t } = this.props

        return (
            <div className="marco_btn float-right mt-1 mr-1" style={{ backgroundColor: "#000" }}>
                <OverlayTrigger
                    trigger="click"
                    key={'legend_popover'}
                    placement={'bottom'}
                    rootClose
                    overlay={
                        <Popover style={{maxWidth: 448, width: 'auto'}}>
                          <Popover.Content >
                            {this.renderLegendContent()}
                          </Popover.Content>
                        </Popover>
                    }>
                        <Button variant="dark" size="sm" className="btn-visor m-1 float-right"><img className="pb-1 mr-2" src={iconoLeyendaBlanco} alt="icono buscador" />{t("leyenda")}</Button>
                </OverlayTrigger>
            </div>
        )
    }

    renderLegendContent = () => {

        const { t } = this.props

        return (
                <div>
                    <div className="row">
                        <div className="col-2" style={{ textAlign: "center" }}>
                            <img className="pt-1" src={leyMarkerSibc} alt="marker sibic" />
                        </div>
                        <div className="col-10">
                            <strong>SIBIC:</strong><br />
                            {t("leyenda-sibic")}
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-2" style={{ textAlign: "center" }}>
                            <img className="pt-1" src={leyMarkerEasin} alt="marker easin" />
                        </div>
                        <div className="col-10">
                            <strong>EASIN:</strong><br />
                            {t("leyenda-easin")}
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-2" style={{ textAlign: "center" }}>
                            <img className="pt-1" src={iconoCapaCluster} alt="leyeneda cluster" />
                        </div>
                        <div className="col-10">
                            <strong>CLUSTER:</strong><br />
                            {t("leyenda-cluster")}
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-2" style={{ textAlign: "center" }}>
                            <img className="pt-1" src={iconoCapaHeatmap} alt="leyenda heatmap" />
                        </div>
                        <div className="col-10">
                            <strong>MAPA DE CALOR:</strong><br />
                            {t("leyenda-mapaCalor")}
                        </div>
                    </div>
                </div>
        )
    }
}

export default withTranslation()(Legend)
